export enum RoleType {
    COLLABORATOR = 'collaborator',
    SUPERUSER = 'superuser',
    ADMIN = 'admin',
    OBSERVER = 'observer',
    COMMUNITY_PARTICIPANT = 'community_participant',
}
